import { clsx, type ClassValue } from 'clsx';

/**
 * Merge class names. Backed by clsx (already a dependency).
 * If you later need Tailwind class de-duplication / override resolution,
 * add `tailwind-merge` and return `twMerge(clsx(inputs))`.
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
